import { Card, Grid, Space, Flex } from 'antd';
import React from 'react';
import { useTheme } from '../GlobalContext/ThemeContext';
import { ReactComponent as LogoWide } from '../../../Images/logo-wide.svg';
import { ReactComponent as LogoWideWhite } from '../../../Images/logo-wide-white.svg';
import Typography from 'antd/es/typography/Typography';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const { useBreakpoint } = Grid;
const { Text } = Typography;

const CommonWrapper = ({ children, forceOverflowScroll = false }) => {
    const { isDarkMode, toggleDarkMode } = useTheme();
    const screens = useBreakpoint() || {};
    const location = useLocation();
    const isMessagesRoute = location.pathname === '/messages';

    return (
        <Flex
            vertical
            style={{
                width: '100%',
                maxWidth: '100dvw',
                minHeight: '100dvh',
                height: '100dvh',
                background: !screens.xs ? `url("https://www.transparenttextures.com/patterns/diamond-upholstery.png"), 
                    linear-gradient(to bottom, ${isDarkMode ? '#1f1f1f, #1f1f1f' : '#e3eef9, #2a588c'})` : '#FFFFFF',
                padding: 0,
                margin: 0,
                overflowY: forceOverflowScroll ? 'auto' : (screens.xs ? 'auto' : 'hidden'),
                overflowX: 'hidden',
            }}
        >
            {/* Main content area */}
            <Flex
                flex={1}
                justify="center"
                align="center"
                style={{
                    padding: screens.xs ? 0 : 10,
                }}
            >
                <Card
                    style={{
                        width: '100%',
                        maxWidth: screens.xs ? '100%' : 400,
                        borderRadius: screens.xs ? 0 : 10,
                        boxShadow: screens.xs ? 'none' : '0 4px 10px rgba(0, 0, 0, 0.2)',
                        padding: '15px 10px',
                        margin: screens.xs ? 0 : '0 10px',
                        background: isDarkMode ? '#1f1f1f' : '#FFFFFF',
                        height: screens.xs ? '100%' : 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        border: screens.xs ? 'none' : isDarkMode ? 'none' : '1px solid #f0f0f0',
                    }}
                    styles={{
                        body: {
                            padding: screens.xs ? '0 10px' : 20,
                        },
                    }}
                >
                    <div style={{ textAlign: 'center', marginBottom: 20 }}>
                        {!isDarkMode ? (
                            <LogoWide style={{ width: '80%' }} />
                        ) : (
                            <LogoWideWhite style={{ width: '80%' }} />
                        )}
                        <Text type="secondary" style={{ display: 'block', marginTop: 10 }}>
                            Log in to your account
                        </Text>
                    </div>
                    <div style={{ flexGrow: 1 }}>
                        {children}
                    </div>
                    <div
                        style={{
                            width: '100%',
                            padding: '10px 0 0 0',
                            borderTop: `1px solid ${isDarkMode ? '#333' : '#f0f0f0'}`,
                        }}
                    >
                        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                            <LanguageSwitcher />
                            <div
                                onClick={toggleDarkMode}
                                style={{
                                    cursor: 'pointer',
                                    fontSize: 20,
                                    color: isDarkMode ? '#fff' : '#000',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {isDarkMode ? <MoonOutlined /> : <SunOutlined />}
                            </div>
                        </Space>
                    </div>
                </Card>
            </Flex>
        </Flex>
    );
};

export default CommonWrapper;